/*
 * @Author: cryi.liu
 * @Date: 2020-06-17 14:18:47
 * @LastEditTime: 2020-06-18 11:36:31
 * @Description: 阅卷数据仓库
 */
export default {
  namespaced: true,

  state: {
    // 题目列表
    questionList: [],
    // 每题已阅卷的用户列表
    markUserAtQuestion: {},
  },

  getters: {
    // 获取题目列表
    questionList({ questionList }) {
      return questionList;
    },
    // 获取每题已阅卷的用户列表
    markUserAtQuestion({ markUserAtQuestion }) {
      return markUserAtQuestion;
    },
  },

  mutations: {
    // 设置题目列表
    setQuestionList(state, { questionList }) {
      state.questionList = questionList;
    },
    // 设置每题已阅卷的用户列表
    setMarkUserAtQuestion(state, { markUserAtQuestion }) {
      state.markUserAtQuestion = markUserAtQuestion;
    },
  },

  actions: {
    invokeSetQuestionList({ commit }, payload) {
      commit('setQuestionList', payload);
    },
    invokeSetMarkUserAtQuestion({ commit }, payload) {
      commit('setMarkUserAtQuestion', payload);
    },
  },
};
